import { insertEmbed } from "editor/actions/blocks";
import { toggleModal } from "editor/actions/ui";
import { EDITOR_MODALS } from "config/constants/editor";
import Log from "utils/log";

export const GET_OEMBED_REQUESTED = "GET_OEMBED_REQUESTED";
export const GET_OEMBED_SUCCEEDED = "GET_OEMBED_SUCCEEDED";
export const GET_OEMBED_FAILED = "GET_OEMBED_FAILED";

export const getOembedRequested = () => {
  return {
    type: GET_OEMBED_REQUESTED,
  };
};

export const getOembedSucceeded = data => {
  return {
    type: GET_OEMBED_SUCCEEDED,
    payload: {
      data,
    },
  };
};

export const getOembedFailed = error => {
  return {
    type: GET_OEMBED_FAILED,
    payload: error,
    error: true,
  };
};

export const getOembedAsync = embedUrl => {
  return (dispatch, getState, getClient) => {
    const api = getClient(dispatch, getState);

    dispatch(getOembedRequested());
    return api.embeds
      .get(embedUrl)
      .then(response => {
        dispatch(getOembedSucceeded(response));
        dispatch(insertEmbed(response));
        dispatch(toggleModal(EDITOR_MODALS.CLOSE));
      })
      .catch(error => {
        // 404s are unsupported embed types. Don't log those to Sentry.
        if (error.context.status !== 404) {
          Log.error(error);
        }
        dispatch(getOembedFailed(error));
      });
  };
};
